<!-- 
	This is the sign in page, it uses the dashboard layout in: 
	"./layouts/Default.vue" .
 -->

<template>
  <div class="sign-in">

    <a-row style="justify-content: space-between;" type="flex" :gutter="[24,24]" justify="space-around" align="middle">

      <!-- Sign In Form Column -->
      <a-col :span="24" :md="12" :lg="{span: 12, offset: 0}" :xl="{span: 6, offset: 2}" class="col-form">
        <h1 class="mb-15">Sign In</h1>
        <h5 class="font-regular text-muted">Enter your email and password to sign in</h5>

        <!-- Sign In Form -->
        <a-form
            id="components-form-demo-normal-login"
            :form="form"
            class="login-form"
            @submit="handleSubmit"
            :hideRequiredMark="true"
        >
          <a-form-item class="mb-10" label="Email" :colon="false">
            <a-input
                v-decorator="[
								'email',
								{ rules: [{ required: true, message: 'Please input your email!' }] },
							]"
                placeholder="Email"
            />
          </a-form-item>
          <a-form-item class="mb-5" label="Password" :colon="false">
            <a-input
                v-decorator="[
								'password',
								{ rules: [{ required: true, message: 'Please input your password!' }] },
							]"
                type="password"
                placeholder="Password"
            />
          </a-form-item>
          <a-form-item class="mb-10">
            <a-switch v-model="rememberMe"/>
            Remember Me
          </a-form-item>
          <a-form-item>
            <a-button type="primary" block html-type="submit" class="login-form-button">
              SIGN IN
            </a-button>
          </a-form-item>
          <p v-if="error" style="color: red;">{{ error }}</p>
        </a-form>
        <!-- / Sign In Form -->

        <p class="font-semibold text-muted">Don't have an account?
          <router-link to="/sign-up" class="font-bold text-dark">Sign Up</router-link>
        </p>
      </a-col>
      <!-- / Sign In Form Column -->

      <!-- Sign In Image Column -->
      <a-col style="padding:0;" class="col-img">
        <div class="svg-container">
          <img src="/images/loginbg.png" alt="">

          <svg style="position: absolute;top: 45%;right: 40%;" version="1.0" xmlns="http://www.w3.org/2000/svg"
               width="100" height="100" viewBox="0 0 4096.000000 4096.000000" preserveAspectRatio="xMidYMid meet">
            <g style="fill:white;" transform="translate(0.000000,4096.000000) scale(0.100000,-0.100000)"
               fill="#000000" stroke="none">
              <path
                  d="M18112 35418 c-19 -19 -17 -8831 2 -8847 10 -8 635 -10 2367 -9 l2354 3 5 2520 5 2520 2120 3 c2427 4 2484 2 2935 -69 310 -49 702 -163 950 -276 208 -94 337 -166 514 -284 340 -229 664 -556 903 -914 245 -367 433 -831 523 -1290 6 -33 14 -69 16 -80 5 -21 16 -87 34 -210 50 -344 54 -863 10 -1240 -23 -193 -65 -407 -112 -570 -198 -679 -538 -1169 -1094 -1575 -61 -45 -81 -57 -244 -155 -125 -75 -354 -185 -465 -223 -33 -12 -105 -37 -159 -57 -127 -45 -454 -128 -616 -155 -242 -41 -399 -60 -655 -80 -101 -8 -2110 -12 -7140 -14 -4967 -2 -7055 -6 -7190 -14 -269 -16 -633 -45 -770 -62 -49 -6 -128 -15 -175 -20 -142 -17 -232 -28 -300 -40 -60 -9 -101 -16 -265 -39 -33 -5 -94 -16 -135 -24 -41 -9 -136 -27 -210 -42 -224 -44 -622 -137 -725 -170 -22 -7 -78 -23 -125 -35 -97 -26 -494 -156 -597 -196 -37 -14 -104 -39 -148 -56 -103 -38 -296 -120 -455 -191 -63 -28 -407 -200 -452 -226 -21 -11 -55 -31 -75 -42 -21 -12 -58 -33 -83 -47 -242 -133 -623 -389 -848 -569 -51 -41 -114 -91 -140 -110 -26 -20 -49 -39 -52 -42 -3 -3 -43 -40 -90 -81 -149 -131 -161 -143 -293 -270 -71 -69 -182 -183 -246 -255 -64 -71 -124 -139 -135 -150 -103 -110 -410 -524 -517 -695 -27 -44 -71 -116 -99 -161 -27 -44 -50 -82 -50 -84 0 -1 -32 -61 -71 -131 -80 -144 -211 -414 -249 -514 -7 -19 -17 -39 -22 -45 -4 -5 -8 -15 -8 -22 0 -8 -9 -33 -20 -55 -11 -23 -20 -45 -20 -50 0 -5 -9 -30 -21 -56 -12 -26 -25 -56 -30 -67 -4 -11 -34 -96 -65 -190 -110 -332 -214 -753 -263 -1065 -7 -41 -16 -97 -21 -125 -5 -27 -14 -93 -20 -145 -6 -52 -15 -126 -20 -165 -13 -98 -27 -260 -41 -465 -13 -198 -6 -1011 10 -1200 12 -147 29 -306 41 -395 5 -38 14 -104 20 -145 29 -215 92 -542 149 -775 44 -178 174 -604 210 -690 5 -11 14 -36 21 -55 7 -19 16 -45 21 -57 5 -13 14 -34 19 -48 6 -14 15 -36 20 -50 6 -14 15 -36 20 -50 6 -14 14 -35 19 -47 44 -111 104 -240 202 -438 88 -176 133 -262 197 -373 12 -20 31 -54 43 -74 53 -94 299 -467 371 -561 210 -278 263 -346 329 -417 25 -27 64 -70 85 -95 147 -170 473 -494 604 -600 30 -25 57 -47 60 -50 12 -14 221 -181 305 -245 179 -136 388 -278 568 -387 100 -61 187 -114 192 -118 31 -25 599 -318 720 -372 33 -15 85 -38 115 -51 233 -103 686 -276 805 -307 17 -4 64 -19 106 -34 42 -14 100 -32 130 -40 30 -9 88 -25 129 -37 120 -34 143 -40 180 -49 19 -4 80 -20 135 -34 634 -160 1461 -272 2238 -302 92 -3 167 -10 167 -15 0 -5 1921 -9 4639 -9 4221 0 4639 1 4645 16 3 9 6 2006 6 4439 0 3989 -2 4423 -16 4429 -20 8 -4672 8 -4701 0 l-23 -6 0 -2524 0 -2524 -2177 0 c-2279 0 -2395 2 -2718 45 -384 50 -775 154 -1075 285 -559 244 -1020 614 -1365 1095 -44 61 -85 120 -92 131 -6 10 -39 63 -71 116 -82 132 -193 359 -262 533 -63 159 -164 513 -190 665 -62 373 -80 579 -80 927 0 304 15 507 56 743 9 47 19 110 24 140 16 91 66 277 113 415 182 538 478 962 913 1311 180 143 324 235 544 346 167 85 212 103 400 169 47 17 94 34 105 39 11 5 72 23 135 39 63 17 142 37 175 46 33 9 84 20 113 26 28 5 78 14 110 19 31 6 82 15 112 20 30 5 82 14 115 20 33 5 114 15 180 21 66 6 156 16 200 21 53 7 2443 13 7180 18 4931 5 7153 11 7275 18 259 16 616 46 745 62 44 6 121 14 170 19 92 10 136 15 240 31 33 5 123 19 200 30 338 50 857 160 1140 241 67 19 184 52 250 71 39 11 78 24 87 29 10 5 27 9 37 9 11 0 23 5 26 10 3 6 15 10 26 10 10 0 27 4 37 9 9 5 62 23 117 40 55 18 109 36 120 41 11 5 93 36 182 69 89 33 181 69 205 79 24 11 77 34 118 52 41 18 95 41 120 52 220 96 731 370 887 476 34 23 65 42 68 42 6 0 178 116 325 219 253 178 625 498 870 748 230 234 501 552 611 716 23 34 68 98 100 142 137 192 317 501 446 765 64 133 122 256 133 285 10 26 25 62 43 105 85 195 216 596 283 865 8 33 19 76 24 95 5 19 14 60 21 90 14 71 27 129 38 183 5 23 15 71 21 107 6 36 15 88 20 115 17 98 30 181 40 263 5 45 14 117 20 160 9 75 19 198 40 472 13 177 13 885 -1 1064 -17 241 -48 535 -68 676 -25 166 -65 388 -91 505 -11 50 -24 110 -30 135 -8 39 -55 222 -76 300 -68 253 -208 657 -300 867 -8 18 -21 50 -30 70 -67 158 -239 503 -319 643 -37 63 -77 133 -89 155 -45 79 -321 492 -383 573 -35 45 -93 121 -129 170 -56 73 -155 194 -174 212 -3 3 -23 25 -44 50 -52 59 -207 230 -227 249 -386 380 -702 647 -1002 851 -12 8 -62 43 -110 77 -48 35 -90 63 -93 63 -3 0 -18 8 -32 19 -15 10 -43 28 -62 39 -19 11 -100 59 -180 107 -337 203 -771 417 -1170 577 -210 85 -614 225 -773 269 -37 10 -100 28 -140 39 -254 72 -619 157 -862 200 -293 52 -513 85 -735 110 -201 23 -269 30 -395 39 -71 6 -166 13 -210 17 -321 25 -742 27 -5140 31 -3614 2 -4644 0 -4653 -9z"/>
            </g>
          </svg>
        </div>
      </a-col>
      <!-- Sign In Image Column -->

    </a-row>

  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      // Binded model property for "Sign In Form" switch button for "Remember Me".
      rememberMe: true,
      error: null, // Voor foutmeldingen
    };
  },
  beforeCreate() {
    // Creates the form and adds to it component's "form" property.
    this.form = this.$form.createForm(this, {name: 'normal_login'});
  },
  methods: {
    // Handles input validation after submission.
    async handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            // Verstuur loginverzoek naar de backend met Basic Auth
            const response = await axios.post('https://pairplex.online/api/login', {
              email: values.email, // Zorg dat 'email' en 'password' veldnamen matchen
              password: values.password,
            }, {
              headers: {
                'Authorization': 'Basic ' + btoa('SilverHawk87' + ':' + '8dIsyquKtY8npVgpksyF'),
                'Content-Type': 'application/json',
                'Accept': 'application/json'
              }

            });

            if (response.data && response.data.message === 'Login successful') {
              sessionStorage.setItem("token", response.data.token);
              this.$router.push('/dashboard');
            }


            // Redirect naar dashboard of andere pagina

          } catch (error) {
            // Toon foutmelding bij mislukte login
            this.error = 'Login mislukt: ' + (error.response?.data?.message || 'Er ging iets mis.');
          }
        }
      });
    },
  },
};
</script>


<style lang="scss">
body {
  background-color: #ffffff;
}
</style>
